// src/main.tsx

import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { StrictMode } from 'react';
import '@/index.css';

// 获取根容器元素
const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find the root element');
}

// 创建 React 根实例
const root = createRoot(container);

// 渲染应用（启用 StrictMode）
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);